import React, { useEffect, useState } from "react";
import axios from "axios";
import ENDPOINT_URL from "../../config";
import { useNavigate } from "react-router-dom";
import "./ReviewerSummary.css";
import { toast } from "react-toastify";

import NavbarReviewer from "../Reviewer/ReviewerUI/NavbarReviewer";
import SidebarReviewer from "../Reviewer/ReviewerUI/SidebarReviewer";

const ReviewerSummary = () => {
  const navigate = useNavigate();

  const [reviewer, setReviewer] = useState({ username: "", email: "" });
  const [evaluations, setEvaluations] = useState([]);
//  START CHANGE: ANC-style global selection
const [selectedIds, setSelectedIds] = useState(new Set());
const headerCbRef = React.useRef(null);
//  END CHANGE

  // FILTER STATES
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");

  const [loading, setLoading] = useState(true);
const [expandedCards, setExpandedCards] = useState({});
  // ---------------- LOAD REVIEWER ----------------
  const loadReviewer = async () => {
    try {
      const res = await axios.get(`${ENDPOINT_URL}/api/reviewer/me`, {
        withCredentials: true,
      });

      setReviewer(res.data || {});
    } catch (err) {
      toast.error(
        err?.response?.data?.error || "Failed to load reviewer details."
      );
    }
  };

  // ---------------- LOAD COMPLETED REVIEWS ----------------
  const fetchEvaluations = async () => {
    try {
      const res = await axios.get(`${ENDPOINT_URL}/api/review/get-form`, {
        withCredentials: true,
      });

      const reviews = Array.isArray(res.data)
        ? res.data
        : res.data.data || [];

      setEvaluations(reviews);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to load evaluations.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReviewer();
    fetchEvaluations();
  }, []);

  // ---------------- DATE HELPERS ----------------
  const getReviewDate = (item) => {
    const d = new Date(item.createdAt);
    return isNaN(d) ? null : d;
  };

  const filterByDate = (item) => {
    const d = getReviewDate(item);
    if (!d) return false;

    let ok = true;
    if (startDate) ok = ok && d >= new Date(startDate);
    if (endDate) ok = ok && d <= new Date(endDate);
    return ok;
  };

  const sortByDate = (a, b) => {
    const da = getReviewDate(a);
    const db = getReviewDate(b);
    if (!da || !db) return 0;

    return sortOrder === "asc" ? da - db : db - da;
  };


  const formatSocialImpact = (value) => {
    if (value === 1 || value === "1") return "Yes";
    if (value === 0 || value === "0") return "No";
    return "-";
  };

  // ========================= SEARCH STATES =========================
const [searchQuery, setSearchQuery] = useState("");
const [debouncedQuery, setDebouncedQuery] = useState("");
useEffect(() => {
  const handler = setTimeout(
    () => setDebouncedQuery(searchQuery),
    300
  );
  return () => clearTimeout(handler);
}, [searchQuery]);
const highlightMatch = (text) => {
  if (!debouncedQuery.trim()) return text;

  const regex = new RegExp(`(${debouncedQuery})`, "gi");
  return text.replace(regex, "<mark>$1</mark>");
};
const applySearch = (item) => {
  if (!debouncedQuery.trim()) return true;

  const name = (item.nameOfApplicant || "").toLowerCase();
  const email = (item.emailOfApplicant || "").toLowerCase();
  const q = debouncedQuery.toLowerCase();

  return name.includes(q) || email.includes(q);
};
const processedEvaluations = [...evaluations]
  .filter(filterByDate)
  .filter(applySearch)
  .sort(sortByDate);

const totalItems = processedEvaluations.length;


//  START CHANGE 1: Pagination states (same replica)
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);

const totalPages = Math.ceil(totalItems / itemsPerPage);

// Slice data for this page
const paginatedEvaluations = processedEvaluations.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);
//  END CHANGE 1

//  Pagination helper (simple)
const handlePageChange = (page) => {
  if (page >= 1 && page <= totalPages) {
    setCurrentPage(page);
  }
};
//  START CHANGE: Update header checkbox indeterminate state
useEffect(() => {
  if (!headerCbRef.current) return;

  const total = processedEvaluations.length;
  const selectedCount = processedEvaluations.filter((item) =>
    selectedIds.has(item._id)
  ).length;

  headerCbRef.current.indeterminate =
    selectedCount > 0 && selectedCount < total;

}, [processedEvaluations, selectedIds]);
//  END CHANGE

  return (
    <>
      <NavbarReviewer />
      <SidebarReviewer />

      <div className="reviewer-summary-wrapper-12ab-reviewersummary">

        {/* ===================== FILTER BAR ===================== */}
        <div className="reviewer-filter-bar-12ab-reviewersummary">

          <div className="filter-item-12ab-reviewersummary">
            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="filter-item-12ab-reviewersummary">
            <label>End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="filter-item-12ab-reviewersummary">
            <label>Sort</label>
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="desc">Newest First</option>
              <option value="asc">Oldest First</option>
            </select>
          </div>
{/* ================= START: Search + Total in One Row ================= */}
<div className="search-total-row-12ab-reviewersummary">

  {/* Search Field */}
  <div className="filter-item-12ab-reviewersummary search-right-12ab-reviewersummary">
    <label>Search</label>

    <div className="search-wrapper-12ab-reviewersummary">
      <input
        type="text"
        placeholder="Search applicant by name, email"
        title="Search applicant by name, email"
        className="input-search-12ab-reviewersummary"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {searchQuery && (
        <button
          type="button"
          title="Clear search"
          className="clear-search-btn-12ab-reviewersummary"
          onClick={() => setSearchQuery("")}
        >
          ×
        </button>
      )}
    </div>
  </div>

  {/* Total Count */}
  <div className="total-count-box-12ab-reviewersummary">
    <div className="total-icon-12ab-reviewersummary">
      <img
        src="/navbar/total-patient.png"
        alt="total"
        className="total-icon-img-12ab-reviewersummary"
      />
    </div>

    <p className="total-label-12ab-reviewersummary">
      Total Applicant:
      <span className="total-number-12ab-reviewersummary">
        {totalItems}
      </span>
    </p>
  </div>

</div>
{/* ================= END: Search + Total ================= */}

        </div>

        {/* ===================== DESKTOP TABLE ===================== */}
        <table className="reviewer-summary-table-anc-12ab-reviewersummary">
          <thead>
            <tr>
                  <th>
      {/* <input
        type="checkbox"
        className="reviewer-checkbox-12ab-reviewersummary"
        onChange={() => {}}
      /> */}
      {/*  START CHANGE: Header checkbox selects ALL filtered evaluations */}
<input
  type="checkbox"
  ref={headerCbRef}
  className="reviewer-checkbox-12ab-reviewersummary"
  checked={
    processedEvaluations.length > 0 &&
    processedEvaluations.every((item) => selectedIds.has(item._id))
  }
  onChange={(e) => {
    const next = new Set(selectedIds);
    const isChecked = e.target.checked;

    processedEvaluations.forEach((item) => {
      if (isChecked) next.add(item._id);
      else next.delete(item._id);
    });

    setSelectedIds(next);
  }}
/>
{/*  END CHANGE */}

    </th>
              <th>S.No</th>
              <th>Applicant</th>
              <th>Applicant Email</th>
              {/* <th>Reviewer</th>
              <th>Reviewer Email</th> */}
              <th>Innovativeness</th>
              <th>Market</th>
              <th>Team</th>
              <th>IPR</th>
              <th>Business Model</th>
              <th>Social Impact</th>
              <th>Remark</th>
              <th>Reviewed On</th>
            </tr>
          </thead>

          <tbody>
              {/* ============= NO RESULTS FOUND ============= */}
  {processedEvaluations.length === 0 && (
    <tr>
      <td
        colSpan="12"
        style={{
          textAlign: "center",
          padding: "18px",
          color: "#666",
          fontSize: "13px",
        }}
      >
        No results found
      </td>
    </tr>
  )}

            {/* {processedEvaluations.map((item, index) => ( */}
            {paginatedEvaluations.map((item, index) => (
              <tr key={item._id || index}>
                  {/* Checkbox Column */}
  <td>
    {/* <input
      type="checkbox"
      className="reviewer-checkbox-12ab-reviewersummary"
    /> */}
    {/*  START CHANGE: Row-level checkbox */}
<input
  type="checkbox"
  className="reviewer-checkbox-12ab-reviewersummary"
  checked={selectedIds.has(item._id)}
  onChange={(e) => {
    const next = new Set(selectedIds);
    if (e.target.checked) next.add(item._id);
    else next.delete(item._id);
    setSelectedIds(next);
  }}
/>
{/*  END CHANGE */}

  </td>
                {/* <td>{index + 1}</td> */}
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                {/* <td>{item.nameOfApplicant || "-"}</td> */}
                <td
  dangerouslySetInnerHTML={{
    __html: highlightMatch(item.nameOfApplicant || "-", debouncedQuery),
  }}
/>
                {/* <td className="reviewer-summary-email-12ab-reviewersummary">
                  {item.emailOfApplicant || "-"}
                </td> */}
                {/* <td
  className="reviewer-summary-email-12ab-reviewersummary"
  dangerouslySetInnerHTML={{
    __html: highlightMatch(item.emailOfApplicant || "-", debouncedQuery),
  }}
/> */}
<td
  className="reviewer-summary-email-12ab-reviewersummary"
  title={item.emailOfApplicant || "-"}
  dangerouslySetInnerHTML={{
    __html: highlightMatch(item.emailOfApplicant || "-", debouncedQuery),
  }}
/>


                {/* <td>{item.nameOfReviewer || "-"}</td>
                <td className="reviewer-summary-email-12ab-reviewersummary">
                  {item.emailOfReviewer || "-"}
                </td> */}

                <td>{item.innovativeness ?? "-"}</td>
                <td>{item.marketOpportunity ?? "-"}</td>
                <td>{item.teamAndExpertise ?? "-"}</td>
                <td>{item.iprInclusivity ?? "-"}</td>
                <td>{item.businessModelAndMarketStrategy ?? "-"}</td>

                <td>{formatSocialImpact(item.hasSocialImpact)}</td>
{/* <td>{item.remark || "-"}</td> */}
<td
  className="remark-cell-12ab-reviewersummary"
  title={item.remark || "-"}
>
  {item.remark
    ? item.remark.length > 20
      ? item.remark.substring(0, 20) + "..."
      : item.remark
    : "-"}
</td>
                <td>
                  {item.createdAt
                    ? new Date(item.createdAt).toLocaleDateString("en-GB")
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ===================== MOBILE CARD VIEW ===================== */}
        <div className="reviewer-summary-card-container-12ab-reviewersummary">
          {/* {processedEvaluations.map((item, index) => ( */}
          {paginatedEvaluations.map((item, index) => (
           
<div
  key={item._id || index}
  // className="reviewer-summary-card-12ab-reviewersummary"
    className={`reviewer-summary-card-12ab-reviewersummary ${
    expandedCards[index] ? "active" : ""
  }`}
  onClick={() =>
    setExpandedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }
  style={{ cursor: "pointer" }}
>
  <p>
    <strong>Applicant:</strong> {item.nameOfApplicant || "-"}
  </p>

  <p>
    <strong>Reviewer:</strong> {item.nameOfReviewer || "-"}
  </p>

  <p>
    <strong>Reviewed On:</strong>{" "}
    {item.createdAt
      ? new Date(item.createdAt).toLocaleDateString("en-GB")
      : "-"}
  </p>

  {/* Expandable details (with animation) */}
  <div
    className={`reviewer-summary-expanded-12ab-reviewersummary ${
      expandedCards[index] ? "active" : ""
    }`}
  >
    <p><strong>Applicant Email:</strong> {item.emailOfApplicant || "-"}</p>
    <p><strong>Reviewer Email:</strong> {item.emailOfReviewer || "-"}</p>

    <p><strong>Innovativeness:</strong> {item.innovativeness ?? "-"}</p>
    <p><strong>Market Opportunity:</strong> {item.marketOpportunity ?? "-"}</p>
    <p><strong>Team & Expertise:</strong> {item.teamAndExpertise ?? "-"}</p>
    <p><strong>IPR Inclusivity:</strong> {item.iprInclusivity ?? "-"}</p>
    <p><strong>Business Model & Strategy:</strong> {item.businessModelAndStrategy ?? "-"}</p>
    <p><strong>Social Impact:</strong> {formatSocialImpact(item.hasSocialImpact)}</p>
      <p><strong>Remark:</strong> {item.remark || "-"}</p>
  </div>
</div>

       
       
       ))}
        </div>
{/*  START PAGINATION UI  */}
<div className="pagination-wrapper-12ab-reviewersummary flex flex-col sm:flex-row sm:justify-between items-start sm:items-center mt-4 mb-6 px-2 w-full gap-2 text-xs">

  {/* PAGE BUTTONS */}
  <div className="page-buttons-12ab-reviewersummary flex items-center space-x-0.5 md:space-x-1 lg:space-x-2">

    {/* Go back 5 pages */}
    {currentPage > 5 && (
      <button
        title="Go back 5 pages"
        onClick={() => setCurrentPage(prev => Math.max(prev - 5, 1))}
        className="px-2 py-1 border rounded-md text-gray-600 hover:bg-gray-200"
      >
        {"<<"}
      </button>
    )}

    {/* Previous */}
    <button
      {...(currentPage !== 1 && { title: "Previous page" })}
      onClick={() => handlePageChange(currentPage - 1)}
      className={`px-2 py-1 border rounded-md transition ${
        currentPage === 1
          ? "disabled-12ab-reviewersummary"
          : "text-gray-600 hover:bg-gray-200"
      }`}
      disabled={currentPage === 1}
    >
      {"<"}
    </button>

    {/* Page numbers (5 at a time) */}
    {(() => {
      const groupStart = Math.floor((currentPage - 1) / 5) * 5 + 1;

      return [...Array(totalPages)]
        .map((_, i) => i + 1)
        .filter(page => page >= groupStart && page < groupStart + 5)
        .map(page => (
          <button
            key={page}
            onClick={() => handlePageChange(page)}
            className={`px-2 py-1 border rounded-md transition ${
              currentPage === page
                ? "active-page-12ab-reviewersummary"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            {page}
          </button>
        ));
    })()}

    {/* Next */}
    <button
      {...(currentPage !== totalPages && { title: "Next page" })}
      onClick={() => handlePageChange(currentPage + 1)}
      className={`px-2 py-1 border rounded-md transition ${
        currentPage === totalPages
          ? "disabled-12ab-reviewersummary"
          : "text-gray-600 hover:bg-gray-200"
      }`}
      disabled={currentPage === totalPages}
    >
      {">"}
    </button>

    {/* Forward 5 pages */}
    {currentPage <= totalPages - 5 && (
      <button
        title="Go forward 5 pages"
        onClick={() =>
          setCurrentPage(prev => Math.min(prev + 5, totalPages))
        }
        className="px-2 py-1 border rounded-md text-gray-600 hover:bg-gray-200"
      >
        {">>"}
      </button>
    )}
  </div>

  {/* Page range text */}
  <div className="page-range-text-12ab-reviewersummary ml-auto hidden md:block text-gray-600 text-[11px] lg:text-xs pl-1">
    {(() => {
      const groupStart = Math.floor((currentPage - 1) / 5) * 5 + 1;
      const groupEnd = Math.min(groupStart + 4, totalPages);
      return `Showing pages ${groupStart}–${groupEnd} of ${totalPages}`;
    })()}
  </div>

  {/* Items per page dropdown */}
  <div className="items-per-page-wrapper-12ab-reviewersummary flex items-center ml-2">
    <select
      value={itemsPerPage}
      onChange={(e) => {
        setItemsPerPage(parseInt(e.target.value));
        setCurrentPage(1);
      }}
      className="border border-gray-300 rounded-md p-0.5 text-gray-600 text-xs"
    >
      <option value="10">10</option>
      <option value="30">30</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>

    <span className="ml-2 text-gray-600 text-[11px] lg:text-xs">/Page</span>
  </div>
</div>
{/*   END PAGINATION UI*/}

      </div>
    </>
  );
};

export default ReviewerSummary;






///////b resp.

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import ENDPOINT_URL from "../../config";
// import { Link, useNavigate } from "react-router-dom";
// import "./ReviewerSummary.css";
// import { IoArrowBack } from "react-icons/io5";
// import { IoHomeOutline } from "react-icons/io5";
// import { IoIosLink } from "react-icons/io";
// import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
// import { toast } from "react-toastify";

// const ReviewerSummary = () => {
//   const navigate = useNavigate();

//   const [reviewer, setReviewer] = useState({ username: "", email: "" });
//   const [evaluations, setEvaluations] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // ==========================================
//   // LOAD REVIEWER PROFILE
//   // ==========================================
//   const loadReviewer = async () => {
//     console.log("API Request: GET /api/reviewer/me");

//     try {
//       const res = await axios.get(`${ENDPOINT_URL}/api/reviewer/me`, {
//         withCredentials: true,
//       });

//       console.log("API Response Data (Reviewer):", res.data);
//       setReviewer(res.data || {});
//     } catch (err) {
//       console.error("API Error (Reviewer):", err);
//       toast.error(
//         err?.response?.data?.error || "Failed to load reviewer details."
//       );
//     }
//   };

//   // ==========================================
//   // FETCH COMPLETED EVALUATIONS (REVIEWS)
//   // ==========================================
//   const fetchEvaluations = async () => {
//     console.log("API Request: GET /api/review/get-form");

//     try {
//       const res = await axios.get(`${ENDPOINT_URL}/api/review/get-form`, {
//         withCredentials: true,
//       });

//       console.log("API Response Data (Evaluations):", res.data);

//       // backend: { success, count, data: [...] }
//       const reviews = Array.isArray(res.data)
//         ? res.data
//         : res.data.data || [];

//       setEvaluations(reviews);
//     } catch (err) {
//       console.error("API Error (Evaluations):", err);
//       toast.error(
//         err?.response?.data?.error || "Failed to load evaluations."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadReviewer();
//     fetchEvaluations();
//   }, []);

//   // ==========================================
//   // LOGOUT
//   // ==========================================
//   const logout = async () => {
//     console.log("API Request: POST /api/logout/reviewer");

//     try {
//       const res = await axios.post(
//         `${ENDPOINT_URL}/api/logout/reviewer`,
//         {},
//         { withCredentials: true }
//       );

//       console.log("API Response Data (Logout):", res.data);
//       navigate("/reviewer-login");
//     } catch (err) {
//       console.error("API Error (Logout):", err);
//       toast.error(err?.response?.data?.error || "Logout failed.");
//     }
//   };

//   const formatSocialImpact = (value) => {
//     if (value === 1 || value === "1") return "Yes";
//     if (value === 0 || value === "0") return "No";
//     return "-";
//   };

//   return (
//     <div className="dashboard-homepage-reviewersummary">
//       {/* ================= SIDEBAR ================= */}
//       <aside className="sidebar-homepage-reviewersummary">
//         <div className="logo-container-homepage-reviewersummary">
//           <div className="logo-homepage-reviewersummary">
//             <img
//               src="/navbar/drishtilogo.jpg"
//               alt="Logo"
//               className="dristilogo-homepage-reviewersummary"
//             />
//           </div>
//         </div>

//         <div className="nav-container-homepage-reviewersummary">
//           <nav className="nav-homepage-reviewersummary">
//             <ul>
//               {/* <li>
//                 <Link to="/reviewer/dashboard">
//                   <IoHomeOutline className="nav-icon-homepage-reviewersummary" />
//                   Dashboard
//                 </Link>
//               </li> */}

//               <li>
//                 <Link to="/reviewer/pipelines/applicant">
//                   <IoIosLink className="nav-icon-homepage-reviewersummary" />
//                   Pipelines Assigned
//                 </Link>
//               </li>

//               <li className="active-reviewersummary">
//                 <Link to="/reviewer/summary">
//                   <IoCheckmarkDoneCircleOutline className="nav-icon-homepage-reviewersummary" />
//                   Reviwed Applications
//                 </Link>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </aside>

//       {/* ================= HEADER ================= */}
//       <header className="header-homepage-reviewersummary">
//         <span className="founder-homepage-reviewersummary">
//           Completed Evaluations
//         </span>

//         <div className="profile-section-homepage-reviewersummary">
//           <div className="user-info-homepage-reviewersummary">
//             <span className="user-initials-homepage-reviewersummary">
//               <img
//                 src="/navbar/login.png"
//                 alt="Login"
//                 style={{ width: "40px" }}
//               />
//             </span>

//             <div className="user-details-homepage-reviewersummary">
//               <span className="user-name-homepage-reviewersummary">
//                 {reviewer.username}
//               </span>
//               <br />
//               <span className="user-email-homepage-reviewersummary">
//                 {reviewer.email}
//               </span>
//             </div>
//           </div>

//           <button
//             className="logout-button-homepage-reviewersummary"
//             onClick={logout}
//           >
//             Logout
//           </button>
//         </div>
//       </header>

//       {/* ================= MAIN CONTENT ================= */}
//       <main className="main-content-homepage-reviewersummary">
//         {/* BACK TO DASHBOARD BUTTON */}
//         <div className="back-btn-container-reviewersummary">
//           <button
//             className="back-btn-reviewersummary"
//             onClick={() => navigate("/reviewer/pipelines/applicant")}
//           >
//             <IoArrowBack className="back-icon-reviewersummary" />
//             Back to Dashboard
//           </button>
//         </div>

//         <section className="content-homepage-reviewersummary">
//           {loading ? (
//             <p className="loading-text-reviewersummary">Loading...</p>
//           ) : evaluations.length === 0 ? (
//             <p className="no-data-reviewersummary">No evaluations found.</p>
//           ) : (
//             <div className="table-wrapper-reviewersummary">
//               <table className="reviewer-summary-table-reviewersummary">
//                 <thead>
//                   <tr>
//                     <th className="th-reviewersummary">Applicant Name</th>
//                     <th className="th-reviewersummary">Applicant Email</th>
//                     <th className="th-reviewersummary">Reviewer</th>
//                     <th className="th-reviewersummary">Reviewer Email</th>
//                     <th className="th-reviewersummary">Innovativeness</th>
//                     <th className="th-reviewersummary">Market Opportunity</th>
//                     <th className="th-reviewersummary">Team & Expertise</th>
//                     <th className="th-reviewersummary">IPR</th>
//                     <th className="th-reviewersummary">
//                       Business Model & Strategy
//                     </th>
//                     <th className="th-reviewersummary">Social Impact</th>
//                     <th className="th-reviewersummary">Reviewed On</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {evaluations.map((item, index) => (
//                     <tr key={index} className="tr-reviewersummary">
//                       <td className="td-reviewersummary">
//                         {item.nameOfApplicant || "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.emailOfApplicant || "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.nameOfReviewer || "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.emailOfReviewer || "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.innovativeness ?? "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.marketOpportunity ?? "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.teamAndExpertise ?? "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.iprInclusivity ?? "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.businessModelAndMarketStrategy ?? "-"}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {formatSocialImpact(item.hasSocialImpact)}
//                       </td>
//                       <td className="td-reviewersummary">
//                         {item.createdAt
//                           ? new Date(item.createdAt).toLocaleDateString()
//                           : "-"}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// export default ReviewerSummary;